import { CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, Injector, NgModule } from '@angular/core'
import { createCustomElement } from '@angular/elements'
import { ElementLoaderComponent } from './loading/components/element-loader.component'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { UpgradeModule } from '@angular/upgrade/static'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { environment } from 'src/environments/environment'
import { logger } from '@utils/logger'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core'
import { DATE_FORMATS } from '@data/date-formats'
import { MomentDateAdapter } from '@angular/material-moment-adapter'

// noinspection JSDeprecatedSymbols
@NgModule({
  declarations: [ElementLoaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserAnimationsModule,
    MatSnackBarModule,
    UpgradeModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  providers: [
        MatDatepickerModule,
        MatNativeDateModule,
        { provide: DateAdapter,
          useClass: MomentDateAdapter,
          deps: [MAT_DATE_LOCALE] ,
        },
        { provide: MAT_DATE_FORMATS,
          useValue: DATE_FORMATS,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule implements DoBootstrap {
  constructor(public injector: Injector, private upgrade: UpgradeModule) {}

  ngDoBootstrap() {
    logger('hello', `environment = ${environment.name}`)
    this.upgrade.bootstrap(document.body, ['app'])

    // export lazy loading custom element
    if (!customElements.get('element-loader')) {
      const ElementLoader = createCustomElement(ElementLoaderComponent, {
        injector: this.injector,
      })
      customElements.define('element-loader', ElementLoader)
    }
  }
}
